import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {Subscription} from "rxjs";
import {Countries} from "../../../enums";

@Component({
    selector: 'app-gather-footer',
    templateUrl: './gather-footer.component.html',
    styleUrls: ['./gather-footer.component.scss'],
    standalone: false
})
export class GatherFooterComponent implements OnChanges, OnDestroy {
  privacyPolicyUrlAquent: string = "https://aquent.com/privacy-policy";
  privacyPolicyUrlSkill: string = "https://skill.com/privacy-policy/";
  private subscriptions = new Subscription();
  @Input() countryId: number = 1;

  ngOnChanges(changes: SimpleChanges) {
    this.countryId = changes.countryId.currentValue;
    this.getPrivacyPolicy(this.countryId);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getPrivacyPolicy(id: number): void {
    if (id) {
      switch (id) {
        case Countries.USA: {
          this.privacyPolicyUrlAquent = "https://aquent.com/privacy-policy";
          break;
        }
        case Countries.DE: {
          this.privacyPolicyUrlAquent = "https://aquent.de/privacy-policy";
          break;
        }
        case Countries.FR: {
          this.privacyPolicyUrlAquent = "https://aquent.fr/privacy-policy/";
          break;
        }
        case Countries.JP: {
          this.privacyPolicyUrlAquent = "https://aquent.co.jp/privacy-policy/";
          break;
        }
        case Countries.AU: {
          this.privacyPolicyUrlAquent = "https://aquent.com.au/privacy-policy";
          break;
        }
        case Countries.UK: {
          this.privacyPolicyUrlAquent = "https://aquent.co.uk/privacy-policy/";
          break;
        }
        case Countries.NL: {
          this.privacyPolicyUrlAquent = "https://aquent.nl/privacy-policy/";
          break;
        }
        default: {
          this.privacyPolicyUrlAquent = "https://aquent.com/privacy-policy";
        }
      }
    }
  }
}
